import api from "../../API/apiConfig";

//1. Lấy danh sách Leads
export const getLeads = async (params) => {
  const queryParams = {
    ...params,
    ownerAlias: params.ownerAlias?.length ? params.ownerAlias : undefined,
  };
  console.log("Param", queryParams);
  console.log("Param", params);
  return await api.get("/leads/list", {
    params: queryParams,
    paramsSerializer: {
      indexes: null,
    }
  });
};

//2. Thêm mới Lead
export const addLead = async (leadData) => {
  return await api.post("/leads/add", leadData);
};

//3. Cập nhật Lead
export const updateLead = async (id, leadData) => {
  return await api.put(`/leads/update/${id}`, leadData);
};

//4. Xóa Lead
export const deleteLead = async (id) => {
  return await api.delete(`/leads/delete/${id}`);
};

//5. Import Leads từ CSV
export const importLeads = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await api.post("/leads/importCSV", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

//6. Đổi chủ sở hữu Lead
export const updateLeadOwner = async (id, ownerId) => {
  return await api.put(`/leads/update-lead-owner/${id}`, { ownerId });
};

//7. Cập nhật trạng thái Lead
export const updateLeadStatus = async (id, data) => {
  return await api.put(`/leads/update-status/${id}`, data);
};

//8. Xem chi tiết Lead
export const getLeadDetail = async (uuid) => {
  return await api.get(`/leads/${uuid}/view`);
};

//9.Import lead từ file CSV
export const importLeadFromCSVFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post("/leads/importCSV", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error uploading CSV file:", error);
    throw new Error("Error uploading CSV file: " + error.message);
  };
};

//10. Export lead
export const exportLead = async (params) => {
  return await api.get("/leads/export", { params });
};

//11. Gán Tag cho Lead
export const assignTagToLead = async (recordId, tagId, type) => {
  return await api.post("/tags/assign", {
    recordId: Array.isArray(recordId) ? recordId : [recordId],
    tagId: Array.isArray(tagId) ? tagId : [tagId],
    type: "LEAD",
  });
};

//12. Get Opportunities cho Convert Lead
export const getOpportunitiesConvert = async (id) => {
  return await api.get(`/opportunities/list?accountId=${id}`);
};

//13. Get Contacts cho Convert Lead
export const getAllContactsConvert = async (id) => {
  return await api.get(`/contacts/list-all?accountId=${id}`);
}

//14. Get All Campaign
export const getAllCampaign = async (id) => {
  return await api.get(`/campaigns`);
}

//15. Add Lead To Campaign
export const addToCampaign = async (campaignId, leadIds) => {
  return await api.post("/leads/add-to-campaign", { campaignId, leadIds });
};

//16.Get Lead in Campaign
export const getLeadsCampaign = async (id) => {
  return await api.get(`/leads/campaign/${id}`);
}
//17. Lead Kanban
export const getLeadsKanban = async (id) => {
  return await api.get(`/leads/kanban`);
}

export const convertLead = async (leadId, convertToContact, contactName, convertToOpportunity, opportunityName) => {
  const requestData = {
    leadId,
    convertToContact,
    contactName,
    convertToOpportunity,
    opportunityName
  };
  return await api.post('/leads/convert', requestData);
};

//18. Get Accessibility cho Lead
export const getAccessibilityForLead = async (leadId) => {
  return await api.get(`/leads/accessibility/${leadId}`);
};

//19. Update Accessibility cho Lead
export const updateAccessibilityForLead = async (leadId, data) => {
  return await api.post(`/leads/update-access/${leadId}`, data);
};
//20. Change Owner
export const changeOwner = async (leadIds, newOwnerUuid) => {
  return await api.put("/leads/change-owner", { leadIds, newOwnerUuid });
};

